window.isObject = function (o) {
  return o === Object(o);
};

var Shared = (function ($) {

  $(document).ready(function () {
    var menu = null;

    Shared.SetupButtons();
    Shared.SignOff();
    Shared.SetDataAttributeForE2ETesting();
    Shared.SetupTheme();
    Shared.TogglePassword.Init();

    $(document).on('click', '.yes-no-toggle:not(.ko-toggle):not(.disabled)', function () {
      var $self = $(this);

      $self
        .find('.btn')
        .toggleClass('btn-default btn-primary active');
    });

    Shared.LeftNav.init();

    //Changed binding to fix IE8 knockout and jquery conflict - http://stackoverflow.com/questions/20528851/knockout-and-jquery-conflict-in-ie-8#answer-20530568 
    $(document).on('click', 'input', function () {
      $(this).trigger('focus');
    });

    //prevent form submit when form has multiple submit buttons and enter key pressed (i.e. Stock Option Exercise Scenarios page)
    //allow-enter class on a submit button will override this (used on the Enter Holdings page)
    $("form").on("keypress", function (e) {
      var elemsSubmit = $('input[type=submit]');
      if (elemsSubmit.length > 1) {
        if (!elemsSubmit.hasClass('allow-enter')) {
          var code = (e.keyCode ? e.keyCode : e.which);
          if (code == 13)
            return false;
        }
      }
    });

    //Prevent multiple submission of forms
    $(document).on('click', 'input[type=submit], button[type=submit], a.delete-item, a.prevent-double-click, input[type=button].prevent-double-click, button.prevent-double-click', function (event) {
      Shared.PreventDoubleClick($(this), event);
    });

    Shared.DisableInputs();

    $.ajaxSetup({ cache: false });  //Prevent caching ajax requests on a global level

    $(document).on("focus change", "input[type=text]", function () {
      this.previousvalue = this.value;
    });

    $(document).on("click", ".btn.cancel", function (event) {
      if (!Settings.ViewOnly)
        if (!confirm('Are you sure you want to lose your changes?'))
          event.preventDefault();
    });

    $(document).on("change", ".format-amount", function (event) {
      var field = $(this);
      var decimalsattr = field.attr("data-val-decimals") != null ? field.attr("data-val-decimals") : 0;
      field.val(formatAmount(field.val(), decimalsattr));
    });

    $(document).on("change", ".format-rate", function (event) {
      var field = $(this);
      var decimalsattr = field.attr("data-val-decimals") != null ? field.attr("data-val-decimals") : 2;
      field.val(formatAmount(field.val(), decimalsattr));
    });

    $(document).on("change", ".format-age-years, .format-age-months", function (event) {
      var field = $(this);
      field.val(formatAmount(field.val(), 0));
    });

    $(document).on("focusout", ".validate-range", function (event) {
      var field = $(this);
      Shared.Validate.dataRange(field, event);
    });

    $(document).on("focusout", "input[type=text]", function () {
      if (this.previousvalue != this.value) {
        $(this).trigger('change');
      }
    });

    $("a.popupCaptivate").on("click", function () {
      var self = $(this);

      var url = self.attr("href");
      var width = self.attr("data-popup-width") || 992;
      var height = self.attr("data-popup-height") || 620;
      var settings = self.attr("data-popup-settings");

      if (settings) {
        if (settings.toLowerCase().indexOf("width") == -1)
          settings += ",width=" + width;
        if (settings.toLowerCase().indexOf("height") == -1)
          settings += ",height=" + height;
      }
      else
        settings = "menubar=no,location=no,status=no,resizable=yes,scrollbars=no,top=0,left=0,screenX=0,screenY=0,width=" + width + ",height=" + height;

      windowHandle = window.open(url, "_blank", settings);
      if (windowHandle.opener) {
        windowHandle.focus();
      }
      return false;
    });
    
    $(document).on("click", "a.dialog", function (e) {
      var self = $(this),
        url = self.attr("href"),
        width = self.attr("data-dialog-width") || 700,
        height = self.attr("data-dialog-height") || 600,
        title = self.attr("data-dialog-title"),
        closeOnOutside = self.attr("data-dialog-closeOnOutside") || true,
        hideClose = self.attr("data-dialog-hideClose");
      Shared.Dialog.Common(self, e, null, width, height, false, closeOnOutside, hideClose, title);
      return false;
    })

    $(document).on("click", "a.popup, a.popup-video", function () {
      var self = $(this);
      var url = self.attr("href");
      var width = self.attr("data-popup-width") || 992;
      var height = self.attr("data-popup-height") || 620;
      var dataPopupName = self.attr("data-popup-name");
      var name = dataPopupName != null ? dataPopupName.replace(/ /g, '') : ("_window" + Math.floor(Math.random() * 10001)); //kluge for popups on popups in ie, null window name or window name with spaces does not always create new window.
      var settings = self.attr("data-popup-settings");

      Shared.PopupWindowHandle = null;

      if (settings) {
        if (settings.toLowerCase().indexOf("width") == -1)
          settings += ",width=" + width;
        if (settings.toLowerCase().indexOf("height") == -1)
          settings += ",height=" + height;
      }
      else {
        settings = "resizable=yes,scrollbars=yes,status=no,width=" + width + ",height=" + height;
      }

      if (Settings.HasPartitionedCookies === 'true') {
        window.location.href = url;
      } else {
        Shared.PopupWindowHandle = window.open(url, name, settings);
      }

      return false;
    });

    //Explain icons
    $(document).on("click", "a.dialog-explain, a.explain", function (event) {
      var self = $(this);
      var width = self.attr("data-popup-width") || 700;
      var height = self.attr("data-popup-height") || 'auto';

      Shared.Dialog.Help(event, self, width, height);

      return false;
    });

    $('.mega-menu').on('click', function (event) {
      var self = $(this);
      var menuId = self.attr("data-menu-id");
      var menu = $("#" + menuId)[0];
      var menuWidth = 0;
      var top = parseInt(jQuery(window).scrollTop()) + 5; //used for if top of page is scrolled down some
      var elemMegaMenuContent = $('.mega-menu-content');

      if (elemMegaMenuContent.length)
        elemMegaMenuContent.fadeOut(800);

      if (!menu) {
        menu = $($.parseHTML($("#" + menuId + "-tmpl").html())).filter("*"); //$($("#" + menuId + "-tmpl").html());
        self.after(menu);
      }

      $(menu)
				.css({ top: 0, left: 0 })
                .show()  //Show must be before position or positioning doesn't work in IE8, life insurance details in particular
				.position({
				  my: "center top",
				  at: "center bottom",
				  offset: "0 3", // + top,
				  of: self,
				  collision: "fit"
				});

      event.preventDefault();
      event.stopPropagation();

      $(document).one("click", function () { $(menu).fadeOut(800); });
    });

    $('a.support-dialog').on('click', function (event) {
      Shared.Dialog.Common($(this), event, "", 350, 350, true, true, false, "Support");
      return false;
    });

    // Hide Toolbar section if no items for it
    $('.toolbar-dropdown-container').each(function () {
      var $self = $(this);

      if ($self.find('li').length) {
        //hidden by default so items do not flicker on DOM load
        $self.show();
      }
    });

    Shared.Toolbar.navBarToggleDisplay();

    //$('.notes-link:not(.bound)').addClass('bound').on('click', function () {
    //  Shared.Toolbar.Notes($(this));
    //  return false;
    //});

    //Use for all info bubbles in the system
    jQuery("a.summary-detail-info").on('click', function (event) {
      var anchor = jQuery(event.currentTarget);
      Shared.Dialog.SummaryDetailInfo(event, anchor, $($.parseHTML(jQuery("#summary-detail-info-" + anchor.attr('id')).html()))); //jQuery("#summary-detail-info-" + anchor.attr('id')).html());
      event.stopPropagation();
      event.preventDefault();
    });

    //stick at the right of the page if we're on an iPad/iPhone due to viewport/page bugs in mobile webkit 
    //(Mainly for the What If Worksheet Page because it is wider than the viewport)
    if (isIOS()) {
      var elemMyWay = $("#floating_myway");
      var elemHelp = $("#floating_help");
      var windowWidth = parseInt($(window).width());
      var documentWidth = parseInt($(document).width());

      if (elemMyWay.length) {
        if (documentWidth > windowWidth) {
          var rightPos = windowWidth - documentWidth;
          elemMyWay.css("position", "absolute").css("right", rightPos);
        }
      }
      if (elemHelp.length) {
        if (documentWidth > windowWidth) {
          var rightPos = windowWidth - documentWidth;
          elemHelp.css("position", "absolute").css("right", rightPos);
        }
      }
    };

    //if no off canvas menu for calculator disable toolbar "Calculators" link and just make it text
    //Only IRA Contribution currently uses the offcanvas menu, maybe one day we will have time to port the
    //other old legacy calculators to be Responsive
    if (!$('.offcanvas-left').length) {
      $('[data-toggle="offcanvasMenu"]').contents().unwrap();
    }

    $('a.zoomer-subpage-navigate-link')
      .on('click', function (event) {
        event.preventDefault();
        var form = $('form');
        var nextUrl = $('<input>')
        .attr('type', 'hidden')
        .attr('name', 'nextUrl')
        .val($(this).attr('href'));

        var data_submit = $(this).data('submit');

        if (data_submit) {
          var submit = $('<input>')
                      .attr('type', data_submit)
                      .attr('name', data_submit);

          form.append(submit);
        }

        form.append(nextUrl);

        if (!form.valid())
          return false;
        form.trigger('submit');
    });

    $('.close-window').on('click', function (event) {
      event.preventDefault();
      window.close();
    });

    $(document).on('click', '.use-loading-indicator', function () {
      Shared.Navigate.Loading($(this));
    });

    //For Web Accessibility
    document.title = Shared.Accessibility.SetPageTitle();
    $('.yes-no-toggle').find('input[type=radio]').attr('tabindex', '-1');

    //$(window).on('resize', function () {
    //  //For RWD purposes (window resizing or device orientation changes)
    //  var stickFooterId = 'sticky-footer-' + this.id;

    //  clearTimeout(stickFooterId);
    //  stickFooterId = setTimeout(Shared.SetFooter(), 250);
    //});

    //Shared.SetFooter();
    Shared.MaskInputs();
  });


return {
  PopupWindowHandle: null,

  DisableInputs: function(selector) {    
    if (Settings.ViewOnly) {
      $('input, select, textarea, .yes-no-toggle')
        .not('.always, .alwaysEnable, input[type="hidden"], input[type="button"], input[type="submit"]')
        .each(function () { PIE.readonly.disable(this); });
    }
    else {
      $('input.disable, select.disable, textarea.disable').each(function () { PIE.readonly.disable(this); });
    }
  },

  SignOff: function () {
    $(document).on('click', '.logout-link', function (e) {

      if (Shared.StorageAvailable('localStorage')) {
        //set and change value to fire storage event listener
        localStorage.setItem('mgpSessionLoggedOut', 'false');
        localStorage.setItem('mgpSessionLoggedOut', 'true');
      }
      if (Shared.StorageAvailable('sessionStorage')) {
        sessionStorage.removeItem('mgpAdminLaunchedSession');
      }
      if (typeof Settings.SignOffUrl !== 'undefined') {
        //Only preventDefault if has Settings.SignOffUrl (exists when AppContext.Session.CurrentUser.Exists) 
        //otherwise allow default event (needed for Inst User Settings)
        e.preventDefault();

        Shared.ClearSpaSessionStorage();
        sessionStorage.setItem('mgpActiveTimerInitialized', 'false');
        window.location.href = Settings.SignOffUrl;
      }
    });

    window.addEventListener('storage', function (e) {
      if (e.key === 'mgpSessionLoggedOut') {
        if (e.newValue === true || e.newValue === 'true') {
          if (typeof Settings.SignOffUrl !== 'undefined') {
            Shared.ClearSpaSessionStorage();
            sessionStorage.setItem('mgpActiveTimerInitialized', 'false');
            window.location.href = Settings.SignOffUrl;
          }
        }
      }
    });
  },

  SetDataAttributeForE2ETesting: function () {
    var elemList = document.querySelectorAll('input:not([type="hidden"]), select, button, a')
    var elemArray = [...elemList]; // converts NodeList to Array

    elemArray.forEach(elem => {
      let origElemId = elem.id;

      if (origElemId.length === 0) {
        origElemId = elem.name;
      }

      if (origElemId.length > 0) {
        let formattedElemId = origElemId.replaceAll('_', '').replaceAll('-', '').replaceAll('.', '');

        formattedElemId = formattedElemId.charAt(0).toUpperCase() + formattedElemId.slice(1);

        elem.setAttribute("data-testid", "e2e" + formattedElemId);
      }
    });
  },

  IsZoomerPopUp: function () {
    try {
      return window.opener ? window.opener.location.href.indexOf('financial-zoomer') > -1 : false;
    } catch (error) {
      return false;
    }
  },

  SetupTheme: function () {
    var isZoomerPopup = Shared.IsZoomerPopUp();

    if (Settings.HasMGDarkThemeOption || isZoomerPopup) {
      if (Settings.UseMGDarkTheme) {
        //Even though moved UseMGDarkTheme to the back-end we still need SetupThemeDisplay for MStar ticker lookup, Support Center, Finish -> Share step popups
        //until dark theme is global and not just in the Financial Goal Plan
        if (isZoomerPopup) {
          Shared.SetupThemeDisplay(true);
        }
      } 
    }
  },

  SetupButtons: function (elem) {
    if (!elem) {
      elem = $(document);
    }

    $(elem).find(".btn")
      .not('.btn-primary')
      .not('.btn-secondary')
      .not('.btn-tertiary')
      .not('.btn-default')
      .not('.btn-cancel')
      .not('.btn-done')
      .not('.btn-md')
      .not('.btn-lg')
      .not('.btn-xl')
      .not('.learn-more-button')
      .not('.btn-to-link')
      .addClass('btn-primary btn-xs')
      .wrap('<span class="bootstrap-wrapper"></span>');
  },

  LocationUpdate: function () {
    window.location.href = window.location.href;
  },

  //Prevent multiple submission of forms
  PreventDoubleClick: function ($elem, event) {
    var timeoutMS = $elem.data('onclick-disable-interval') ? $elem.data('onclick-disable-interval') : 5000;
    var onClickDisableBtn = $elem.data('onclick-disable-btn') ? $elem.data('onclick-disable-btn') : false; //Implemented for JIRA MGP-817 (legacy code form submits)

    if (!$elem.data('isClicked')) {
      var item = $elem;

      if (onClickDisableBtn) {
        $elem.prop('disabled', true);
      }
      item.data('isClicked', true);

      setTimeout(function () {
        if (onClickDisableBtn) {
          $elem.prop('disabled', false);
        }
        item.removeData('isClicked');
      }, timeoutMS);
    }
    else {
      if (onClickDisableBtn) {
        $elem.prop('disabled', true);
      }
      event.preventDefault();
      return false;
    }
  },

  MaskInputs: function () {
    // Form Field Masking
    // Added clearIncomplete: true for all dates, removeMaskOnSubmit: true just for 
    //yyyy (adding for others breaks validation b/c it removes the "/" character) - Case 8334
    if (!Shared.Browser.IsAndroid()) {
      $('.phoneNumber').inputmask({
        mask: '999-999-9999[x9{1,5}]', greedy: false
      });
      $('.phoneNumberNoExt').inputmask({
        mask: '999-999-9999', greedy: false
      });
    }
  },
  Browser: {
    IsAndroid: function () {
      var userAgent = navigator.userAgent.toLowerCase();
      //Since many websites do use this kind of OS detection, but ignore Windows Phone, 
      //Microsoft decided to put "Android" and "iPhone" into the userAgent String as well.
      if (!/iemobile/i.test(userAgent)) {
        if (/android/i.test(userAgent)) {
          return true;
        }
      }
      return false;
    }
  },
  Validate:
  {
    selectInput: function (field, msg) {
      if (field.length && field.attr('type') != 'hidden') {
        if (field.val() == '' || field.val() == 0) {
          field.trigger('focus');
          Shared.Alert.display(field, msg);
          return false;
        }
      }
      return true;
    },
    radioInput: function (field, msg) {
      if (field.length && field.attr('type') != 'hidden') {
        if (!field.is(':checked')) {
          field.filter(":first").trigger('focus');
          Shared.Alert.display(field, msg);
          return false;
        }
      }
      return true;
    },
    descInput: function (field, msg) {
      if (field.length && field.attr('type') != 'hidden') {
        var desc = jQuery.trim(field.val());

        if (desc == '') {
          field.trigger('focus');
          Shared.Alert.display(field, msg);
          return false;
        }
        if (grExcludedCharactersDescField(field))
          return false;
      }
      return true;
    },
    descAlphaInput: function (field, msg) {
      if (field.length && field.attr('type') != 'hidden') {
        var desc = jQuery.trim(field.val());

        if (!desc.match(/^[a-zA-Z\s]+$/)) {
          field.trigger('focus');
          Shared.Alert.display(field, msg);
          return false;
        }
        if (grExcludedCharactersDescField(field))
          return false;
      }
      return true;
    },
    dateInput: function (field, msg, format, timeframe, yearlimit, enforcetype, required, allowtoday) {
      var isValid;
      if (field.length && field.attr('type') != 'hidden') {
        if (allowtoday)
          isValid = validateDateInputAllowToday(field[0], format, timeframe, yearlimit, enforcetype);
        else
          isValid = validateDateInput(field[0], format, timeframe, yearlimit, enforcetype);

        if (isValid && required)
          isValid = field.val() == '' ? false : true;

        if (!isValid) {
          field.val('');
          field[0].focus();
          Shared.Alert.display(field, msg);
          return false;
        }
      }
      return true;
    },
    userIdInput: function (field, msg) {
      if (field.length && field.attr('type') != 'hidden') {
        var userId = jQuery.trim(field.val());

        if (userId.search(/^[A-Za-z0-9@._-][A-Za-z0-9@._-][A-Za-z0-9@._-][A-Za-z0-9@._-][A-Za-z0-9@._-]+$/) != -1) {
          return true;
        }
        else {
          field.trigger('focus');
          Shared.Alert.display(field, msg);
          return false;
        }
      }
      return true;
    },
    emailInput: function (field, msg, required) {
      if (field.length && field.attr('type') != 'hidden') {
        var email = jQuery.trim(field.val());

        if ((!required && email.length == 0) || EMAIL_VALIDATION_REGEX.test(email)) {
          return true;
        }
        else {
          field.trigger('focus');
          Shared.Alert.display(field, msg);
          return false;
        }
      }
      return true;
    },
    dataRange: function (field) {
      if (!field.hasClass("override-validate-range")) {
        var minattr = field.attr("data-val-range-min") != null ? field.attr("data-val-range-min") : 0;
        var maxattr = field.attr("data-val-range-max") != null ? field.attr("data-val-range-max") : 9999999;
        var msgattr = field.attr("data-val-range-msg") != null ? field.attr("data-val-range-msg") : "Please enter a valid value between <span class='no-wrap'>{min}</span> and <span class='no-wrap'>{max}</span>.";
        var decimalsattr = field.attr("data-val-decimals") != null ? field.attr("data-val-decimals") : 0;
        var formatattr = field.attr("data-val-format") != null ? field.attr("data-val-format") : "$";
        var oncomplete = field.attr("data-val-oncomplete");
        var bOK = true;

        var min = PIE.number.toFloat(minattr);
        var max = PIE.number.toFloat(maxattr);

        if (isNaN(min)) {
          var fMin = eval("false ||" + minattr);
          if (typeof fMin === "function")
            min = PIE.number.toFloat(fMin());
        }
        if (isNaN(max)) {
          var fMax = eval("false ||" + maxattr);
          if (typeof fMax === "function")
            max = PIE.number.toFloat(fMax());
        }

        if (isNaN(min) || isNaN(max))
          Shared.Alert.display(field, "This field cannot be validated.");

        var value = PIE.number.toFloat(field.val());

        if (formatattr == "%")
          msgattr = msgattr.replace("{min}", formatPercent(min, decimalsattr)).replace("{max}", formatPercent(max, decimalsattr));
        else if (formatattr == "$")
          msgattr = msgattr.replace("{min}", formatCurrency(min, decimalsattr)).replace("{max}", formatCurrency(max, decimalsattr));
        else if (formatattr == "#") // added for simple integers with no added commas or prefixes, such as years
          msgattr = msgattr.replace("{min}", PIE.number.toInt(min)).replace("{max}", PIE.number.toInt(max));
        else
          msgattr = msgattr.replace("{min}", formatAmount(min, decimalsattr)).replace("{max}", formatAmount(max, decimalsattr));

        if (value < min) {
          field.val(formatattr === "#" ? min : formatAmount(min, decimalsattr))
          bOK = false;
        }
        else if (value > max) {
          field.val(formatattr === "#" ? max : formatAmount(max, decimalsattr))
          bOK = false;
        }

        if (!bOK) {
          Shared.Alert.display(field, msgattr);
          return false;
        }

        Shared.Alert.destroy(field);

        if (typeof oncomplete != undefined) {
          var fOnComplete = eval("false ||" + oncomplete);
          if (typeof fOnComplete === "function")
            fOnComplete();
        }
      }
      return true;
    }
  },

  Toggle:
    {
      //container: function (container, section) {
      //  jQuery('#' + container + " #toggle-" + section).on('click', function (event) {
      //    var self = jQuery(this);
      //    var selfText = self.text();
      //    var selfDiv = self.find("div");
      //    var $elem = $("#" + container + " ." + section);

      //    if ($elem.is(":visible")) {
      //      $elem.addClass('visibility hidden');
      //    } else {
      //      $elem.removeClass('visibility hidden');
      //    }
      //    //jQuery("#" + container + " ." + section)
      //    //    .toggle()
      //    //    .is(":visible");

      //    if (selfDiv.length)
      //      selfDiv.toggleClass("contract").toggleClass("expand");
      //    else if (selfText == "More" || selfText == "Less")
      //      selfText == "More" ? self.text("Less") : self.text("More");
      //    else if (self.text() == "Show" || self.text() == "Hide")
      //      selfText == "Show" ? self.text("Hide") : self.text("Show");

      //    event.preventDefault();  //prevent toggling from taking you back to top of page
      //  });
      //},
      section: function (section) {
        jQuery("#toggle-" + section).on('click', function (event) {
          var self = jQuery(this);
          var selfText = self.text();
          var selfDiv = self.find("div");
          var $elem = $("." + section);

          if ($elem.is(":visible")) {
            $elem.addClass('visibility hidden');
          } else {
            //If the hidden toggle section element(s) are using inline style="display:none" instead of the visibility or hidden class remove it
            for (var i = 0; i < $elem.length; i++) {
              $elem[i].style.display = '';
            }
            $elem.removeClass('visibility hidden');
          }
          //jQuery("." + section)
          //    .toggle()
          //    .is(":visible");

          if (selfDiv.length)
            selfDiv.toggleClass("contract").toggleClass("expand");
          else if (selfText == "More" || selfText == "Less")
            selfText == "More" ? self.text("Less") : self.text("More");
          else if (self.text() == "Show" || self.text() == "Hide")
            selfText == "Show" ? self.text("Hide") : self.text("Show");

          event.preventDefault();  //prevent toggling from taking you back to top of page
        });
      },
      show: function (section) {
        var toggleIcon = jQuery("#toggle-" + section);
        var sectionText = toggleIcon.text();
        var sectionDiv = toggleIcon.find("div");
        jQuery("." + section).removeClass('visibility hidden'); //jQuery("." + section).show();

        if (sectionDiv.length)
          sectionDiv.removeClass("expand").addClass("contract");
        else if (sectionText == "More" || sectionText == "Less")
          toggleIcon.text("Less");
        else if (sectionText == "Show" || sectionText == "Hide")
          toggleIcon.text("Hide");
      },
      hide: function (section) {
        var toggleIcon = jQuery("#toggle-" + section);
        var sectionText = toggleIcon.text();
        var sectionDiv = toggleIcon.find("div");
        jQuery("." + section).addClass('visibility hidden'); //jQuery("." + section).hide();

        if (sectionDiv.length)
          sectionDiv.removeClass("contract").addClass("expand");
        else if (sectionText == "Less" || sectionText == "More")
          toggleIcon.text("More");
        else if (sectionText == "Hide" || sectionText == "Show")
          toggleIcon.text("Show");
      }
    },

  Format:
    {
      numeric: function (field) {
        if (field.length) {
          if (field.is('[value]')) //(field.attr('value') !== undefined)
            var val = field.val().replace(/[^\d\.]/g, "");
          else
            var val = field.text().replace(/[^\d\.]/g, "");

          if (val != '')
            return parseFloat(val);
        }
        return 0;
      }
    },

  Dialog:
    {
      PleaseWaitDialog: null,
      CommonDialog: null,

      PleaseWait: function (pMsg, pShowClose) {
        var msg = "Please Wait While We Process Your Request ...";
        var showClose = true;
        var timerId = 0;

        if (pMsg)
          msg = pMsg;

        if (pShowClose == false)
          showClose = pShowClose;

        if (!jQuery('#please-wait-dialog').length)
          jQuery('<div id="please-wait-dialog" style="display:none;"></div>').appendTo('body');

        Shared.Dialog.PleaseWaitDialog = jQuery("#please-wait-dialog").dialog({
          modal: true,
          height: 'auto',
          width: 470,
          zIndex: 1000,
          resizable: false,
          draggable: false,
          closeOnEscape: false,
          position: { my: 'center top', at: 'center top+30', of: window }, //position: ['middle', 30]
          dialogClass: 'please-wait-dialog',
          open: function (event, ui) {
            jQuery(this).closest(".ui-dialog").find(".ui-dialog-titlebar:first").hide();
          },
          close: function (event, ui) {
            window.clearTimeout(timerId);
          }
        })

        Shared.Dialog.PleaseWaitDialog.html("<div class='please-wait-indicator' style='line-height:100px; height:100px;'></div><div class='inline-block' style='line-height:100px; text-align:left; width:390px; vertical-align:middle;'><div class='pleasewait inline-block' style='line-height:20px; vertical-align:middle;'>" + msg + "</div></div>");
        Shared.Dialog.PleaseWaitDialog.dialog("open");

        timerId = window.setTimeout(function () {
          if (showClose) {
            Shared.Dialog.PleaseWaitDialog.dialog("option", "buttons", [
            {
              text: "Close",
              click: function () {
                jQuery(this).dialog("close");

                try {
                  window.stop();
                } catch (exception) {
                  window.document.execCommand('Stop');
                }

                window.clearTimeout(timerId);
              }
            }
            ]);
            jQuery(this).closest(".ui-dialog-buttonpane").find("button:contains('Close')").addClass("btn"); //IE8 buggy so do this instead
          }
        }, 45000);
      },
      PleaseWaitClose: function () {
        if (Shared.Dialog.PleaseWaitDialog)
          Shared.Dialog.PleaseWaitDialog.dialog("close");
      },
      Help: function (e, obj, width, height) {
        if (!jQuery('#dialogHelp').length)
          jQuery('<div id="dialogHelp" style="display:none;"></div>').appendTo('body');

        e.preventDefault();

        var dia = jQuery('#dialogHelp').dialog({
          width: width,
          height: height,
          autoOpen: false,
          stack: true,
          zIndex: 9999999,
          position: { my: 'center top', at: 'center top+30', of: window }, //position: ['middle', 30]
        }).css("maxHeight", 600);

        dia.html('');

        if (obj.attr('href').length) {
          dia.load(obj.attr('href'), function () {
            jQuery('#WaitingForHelp').hide();
            dia.dialog({ title: 'Explain' });
            dia.dialog('open');
          });
        } else {
          dia.html('<p>No help is currently available.</p>');

          dia
                .dialog({ title: 'No Help Available' })
                .dialog('open');
        }
        Shared.SetupButtons('#dialogHelp');
      },
      SummaryDetailInfo: function (event, anchor, content) {
        if (!jQuery('#dialogSummaryDetailInfo').length)
          jQuery('<div id="dialogSummaryDetailInfo" style="display:none;"></div>').appendTo('body');

        if (jQuery('#dialogSummaryDetailInfo').length) {
          var dia = jQuery('#dialogSummaryDetailInfo').dialog({
            title: $.parseHTML('Details')[0].textContent, //https://bugs.jqueryui.com/ticket/6016
            dialogClass: 'dialog-summary-detail-info',
            width: 360,
            minHeight: 80,
            resizable: false,
            close: function (event, ui) {
              jQuery(this).dialog("destroy");
              jQuery(this).html("");
            }
          }).height("auto");
        }

        dia.html('');
        dia.append(content);
        dia.dialog('open');
        dia.dialog('widget').position({ my: 'right top', at: 'left bottom', of: anchor });

        jQuery(document).on('click', function (event) {
          if (dia.hasClass('ui-dialog-content')) {
            if (dia.dialog('isOpen') && !jQuery(event.target).is('.ui-dialog, a') && !jQuery(event.target).closest('.ui-dialog').length) {
              dia.dialog('close');
            }
          }
        });
        Shared.SetupButtons('#dialogSummaryDetailInfo');
      },
      Common: function (obj, event, content, width, height, modal, closeOnOutsideClick, hideClose, title) {
        if (!jQuery('#dialogCommon').length)
          jQuery('<div id="dialogCommon" style="display:none;"></div>').appendTo('body');

        if (event != null)
          event.preventDefault();

        Shared.Dialog.CommonDialog = jQuery('#dialogCommon').dialog({
          width: width,
          height: height,
          modal: modal,
          title: $.parseHTML(title)[0].textContent, //https://bugs.jqueryui.com/ticket/6016
          closeOnEscape: hideClose,
          autoOpen: true,
          stack: true,
          position: { my: 'center top', at: 'center top+30', of: window }, //position: ['middle', 30]
          open: function (event, ui) {
            if (hideClose)
              jQuery(".ui-dialog-titlebar-close", ui.dialog).hide();
          }
        })
        Shared.Dialog.CommonDialog.html('');

        if (obj != null && obj.attr('href').length && obj.attr('href') != '#') {
          Shared.Dialog.CommonDialog.load(obj.attr('href'));
        }
        else {
          Shared.Dialog.CommonDialog.append(content);
          Shared.Dialog.CommonDialog.dialog('open');
        }

        if (closeOnOutsideClick) {
          if (!modal) {
            jQuery(document).on('click', function (event) {
              if (Shared.Dialog.CommonDialog.hasClass('ui-dialog-content')) {
                if (Shared.Dialog.CommonDialog.dialog('isOpen') && !jQuery(event.target).is('.ui-dialog, a') && !jQuery(event.target).closest('.ui-dialog').length) {
                  Shared.Dialog.CommonDialog.dialog('close');
                }
              }
            });
          }
          else {
            jQuery('.ui-widget-overlay').on('click', function (event) {
              Shared.Dialog.CommonDialog.dialog('close');
            });
          }
        }
        Shared.SetupButtons('#dialogCommon');
      },
      CommonClose: function () {
        Shared.Dialog.CommonDialog.dialog("close");
      }
    },

  Alert:
    {
      display: function (field, msg) {
        if (field) {
          field.each(function () {
            if (!jQuery(this).hasClass("error-input"))
              jQuery(this).addClass("error-input");
          });

          var msg = msg.replace(/'/g, "&#39;").replace(/"/g, "&#39;")

          field.parent().find('.error-info').remove();
          field.parent().find('.text-error-info').remove();

          if ($('#ShowTextErrorInfo').length)
            var errMsg = "<div class='text-error-info'>" + msg + "</div>";
          else
            var errMsg = "<div class='error-info' title='" + msg + "'></div>";

          if (field.attr('type') == 'radio' || field.attr('type') == 'checkbox') {
            var $toggleElem = field.parents('.yes-no-toggle:first');

            if ($toggleElem.length) {
              $toggleElem.addClass('error-input');
              $toggleElem.after(errMsg);
            }
            else if (field.siblings('span').length) {
              field.siblings('span').after(errMsg);
            }
            else {
              if (field.parents('.editor-label').length)
                field.parents('.editor-label').append(errMsg);
              else if (field.parents('.editor-input').length)
                field.parents('.editor-input').append(errMsg);
              else {
                if (field.attr('type') == 'radio')
                  field.siblings('.radio').after(errMsg);
                else if (field.attr('type') == 'checkbox')
                  field.before(errMsg);
              }
            }
          }
          else {
            if ($.trim(field.parent().text()) == '%')
              field.parent().append(errMsg);
            else
              field.after(errMsg);
          }

          if (!$('#ShowTextErrorInfo').length) {
            Tooltip.custom(field.parent().find('.error-info'));
          }

        }
        else {
          alert(msg);
        }
      },
      destroyAll: function () {
        jQuery('.error-input').each(function (index) {
          jQuery(this).removeClass("error-input");
        });
        jQuery('.error-info').each(function (index) {
          jQuery(this).remove();
        });
        jQuery('.text-error-info').each(function (index) {
          jQuery(this).remove();
        });
      },
      destroy: function (field) {
        if (field.length) {
          field.removeClass("error-input");
          field.find(".error-input").removeClass("error-input"); //for yes-no-toggle container
          field.parent().find(".error-info").remove();
          field.parent().find(".text-error-info").remove();
        }
      }
    },

    LeftNav:
    {
      init: function () {
        var elemNav = jQuery('#nav');
        var elemMainContainer = jQuery('#main-container');
        var elemLeftNavContainer = jQuery('#left-nav-container');
        var elemContentContainer = jQuery('#content-container');

        if (elemNav.find('div.navcontent').find('div').length > 1) {
          var elemWindow = jQuery(window);
          var elemDocument = jQuery(document);
          var elemToolbar = jQuery('#toolbar');
          var elemNavIconHide = jQuery('div.hide-nav-icon');

          var mainWidth = elemMainContainer.width();
          var leftNavWidth = elemLeftNavContainer.width();
          var contentWidth = elemContentContainer.width();
          var navIconLeft = elemNavIconHide.css('left');

          elemDocument.on("click", "div.hide-nav-icon", function (event) {
            var self = jQuery(this);
            var duration = 200;
            var isDefaultLeftNavHidden = jQuery('input[name=DefaultLeftNavHidden]').length;

            elemNav.css('width', '0px');
            elemLeftNavContainer.css('width', '0px');
            elemContentContainer.css('max-width', 790 + 'px'); //elemContentContainer.css('width', mainWidth + 'px').css('left', '0px');
            self.toggleClass('hide-nav-icon show-nav-icon').attr('title', 'Show Left Navigation');
            var elemNavIconShow = jQuery('div.show-nav-icon');

            if (isDefaultLeftNavHidden) {  //Presentation Left Nav is defaulted to hidden so no slide effect
              elemNavIconShow.css('left', '0px').show();
              elemNav.hide();
            }
            else {
              elemNavIconShow.css('left', '0px').show('slide', { direction: 'left', distance: navIconLeft }, duration);
              elemNav.hide('slide', { direction: 'left', distance: leftNavWidth + 'px' }, duration);
            }
          });

          elemDocument.on("click", "div.show-nav-icon", function (event) {
            var self = jQuery(this);
            var duration = 200;

            leftNavWidth = leftNavWidth == 0 ? 170 : leftNavWidth;
            navIconLeft = navIconLeft == '0px' ? '147px' : navIconLeft;

            elemNav.css('width', leftNavWidth + 'px');
            elemLeftNavContainer.css('width', leftNavWidth + 'px');
            elemContentContainer.css('max-width', contentWidth + 'px'); //elemContentContainer.css('width', contentWidth + 'px').css('left', leftNavWidth + 'px');
            self.toggleClass('hide-nav-icon show-nav-icon').attr('title', 'Hide Left Navigation');
            elemNavIconHide.css('left', navIconLeft).show("slide", { direction: 'left', distance: navIconLeft }, duration);
            elemNav.show('slide', { direction: 'left', distance: leftNavWidth + 'px' }, duration);
          });

          jQuery("#nav div.navtextsectionhdrnotactive, #nav div.navtextsectionhdr").on("click", function (event) {
            var self = jQuery(this);
            var elem = self.children('a:first');
            var elemId = elem.attr('id');

            // For some browsers, `attr` is undefined; for others, // `attr` is false.  Check for both.
            if (typeof elemId !== 'undefined' && elemId !== false) {
              self.toggleClass('navtextsectionhdrnotactive navtextsectionhdr');
              var selector = jQuery('#nav').find('div.' + elemId.replace('toggle-', ''));
              selector.slideToggle(200);
              event.preventDefault();
            }
            else {
              if (self.hasClass('navtextsectionhdrnotactive')) //Used for Estate and Reports section headers
                window.location.href = elem.attr('href');
            }
          });

          if (jQuery('input[name=DefaultLeftNavHidden]').length || window.matchMedia('(max-width: 960px)').matches)  //Use 960px because of legency code
            jQuery('div.hide-nav-icon').trigger('click');
        }
        else {
          if (elemLeftNavContainer.length) {
            elemLeftNavContainer.remove();
            elemContentContainer.width(elemMainContainer.width()).css('margin-left', '0px');
          }
        }
      }
    },

    Toolbar:
    {
      //Notes: function (self) {
      //  var modal = $('#notes-dialog');

      //  if (modal.length === 0) {
      //    modal = $("<div id='notes-dialog' class='simplemodal-overlay' style='display:none;'></div>");
      //    $("body").append(modal);
      //  }

      //  $.ajax(
      //  {
      //    type: 'GET',
      //    url: self.attr("href"),
      //    dataType: 'json',
      //    cache: false,
      //    success: function (data, textStatus, jqXHR) {
      //      $(modal)
      //      .html(data.Html)
      //      .modal(
      //        {
      //        onShow: function (dialog) {
      //          if (typeof (HouseholdNotes) !== 'undefined') {
      //            HouseholdNotes.Init();  //household notes
      //          } else {
      //            notes.init(); //plan notes
      //            Shared.SetupButtons(dialog.data);
      //          }
      //        },
      //        onClose: function () {
      //          $.modal.close();
      //          modal.remove();
      //        },
      //        closeHTML: "<div class='bootstrap-wrapper'><a href='#' aria-label='Close' class='modal-close pull-right'><i class='fa fa-times' aria-hidden='true'></i></a></div>",
      //        minHeight: 680,
      //        minWidth: 900,
      //        maxHeight: 680,
      //        maxWidth: 900,
      //        close: true
      //      });
      //    }
      //  });
      //  return false;
      //},

      //Only ever show Bootstrap hamburger menu when there are menu items
      navBarToggleDisplay: function () {
        var $navbar = $('#navbar');

        if (!$navbar.find('.toolbar-dropdown-container').find('li').length &&
          !$navbar.find('.support').length &&
          $navbar.find('.logout').is(':empty')) {
          $('.navbar-toggle').addClass('hidden');
        }
      }
    },

    Accessibility: {
      YesNoToggleByArrowKeys: function (event) {
        var keyCode,
            $yesNoToggleElem = $(event.target),
            LEFT_ARROW_KEY = 37,
            UP_ARROW_KEY = 38,
            RIGHT_ARROW_KEY = 39,
            DOWN_ARROW_KEY = 40;

        keyCode = (event.which ? event.which : event.keyCode);

        if (keyCode === LEFT_ARROW_KEY || keyCode === UP_ARROW_KEY ||
          keyCode === RIGHT_ARROW_KEY || keyCode === DOWN_ARROW_KEY) {
          if (!$yesNoToggleElem.hasClass('disabled')) {
            $yesNoToggleElem.trigger('click');
          }
        }
      },

      SetPageTitle: function () {
        var defaultTitle = document.title,
            $titleDescElem = null,
            $pageHeader = $('.pageheader').first(),
            $h1Header = $('h1').first(),
            $h2Header = $('h2').first(),
            $h3Header = $('h3').first();

        if ($pageHeader.length) {
          $titleDescElem = $pageHeader;
        }
        else if ($h1Header.length) {
          $titleDescElem = $h1Header;
        }
        else if ($h2Header.length) {
          $titleDescElem = $h2Header;
        }
        else if ($h3Header.length) {
          $titleDescElem = $h3Header;
        }

        if ($titleDescElem) {
          return $titleDescElem.clone().children().remove().end().text() + ' | ' + defaultTitle;
        }
        else {
          return defaultTitle;
        }
      }
    },

    Navigate: {
      Loading: function ($elem) {
        if ($elem.hasClass('use-loading-indicator')) {
          if (!$elem.children(':first').hasClass('nav-waiting')) {
            $elem.prepend('<i class="fa spinner fa-spin nav-waiting" aria-label="Loading"' +
            'aria-live="assertive" aria-busy="true" role="alert"></i> ');
          }
        }
      },

      LoadingStop: function () {
        var $navWaiting = $('.nav-waiting');

        if ($navWaiting.length > 0) {
          $navWaiting.remove();
        }
      }
    },

    //https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#Feature-detecting_localStorage
    //Feature detect if browser storage is available
    StorageAvailable: function (type) {
      try {
        var storage = window[type],
            x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
      }
      catch (e) {
        return false;
      }
    },

    ClearSpaSessionStorage: function () {
      try {
        store.session.namespace('moneyguide.financial-zoomer.' + Settings.HouseholdId).clear();
        store.session.namespace('moneyguide.snapshot.' + Settings.HouseholdId).clear();
        store.session.namespace('moneyguide.wealthstudios.' + Settings.HouseholdId).clear();
      }
      catch (e) {
        return false;
      }
    },

    TogglePassword: {
      Init: function () {
        let togglePasswordBtns = document.querySelectorAll('.password-toggle-icon');

        togglePasswordBtns.forEach(togglePasswordBtn => {
          togglePasswordBtn.addEventListener('click', function (event) {
            Shared.TogglePassword.SetVisibility(event.currentTarget);
          });
        });
      },

      SetVisibility: function (togglePasswordBtn) {
        let togglePasswordIcon = togglePasswordBtn.getElementsByTagName('i')[0];
        let previousSiblings = Shared.TogglePassword.GetAllPreviousSiblings(togglePasswordBtn);
        let passwordField;

        for (let i = 0; i < previousSiblings.length; i++) {
          if (previousSiblings[i].name?.toLowerCase().indexOf('password') >= 0) {
            passwordField = previousSiblings[i];
            break;
          }
        }

        if (passwordField) {
          if (passwordField.type === 'password') {
            passwordField.type = 'text';
            togglePasswordBtn.setAttribute('aria-label', 'Hide Password');
            togglePasswordIcon.title = 'Hide Password';
            togglePasswordIcon.classList.remove('fa-eye');
            togglePasswordIcon.classList.add('fa-eye-slash');
          } else {
            passwordField.type = 'password';
            togglePasswordBtn.setAttribute('aria-label', 'Show Password');
            togglePasswordIcon.title = 'Show Password';
            togglePasswordIcon.classList.remove('fa-eye-slash');
            togglePasswordIcon.classList.add('fa-eye');
          }
        }
      },

      GetAllPreviousSiblings: function (element) {
        const siblings = [];
        let current = element.previousElementSibling;

        while (current) {
          siblings.push(current);
          current = current.previousElementSibling;
        }
        return siblings;
      }
    }

    //Sticky Footer
    //SetFooter: function () {
    //  $('body').css('margin-bottom', $('#footer').height());
    //}

  } //end return

})(jQuery);


var Tooltip = 
{
  custom: function (elem) {
    //Needed to handle jQueryUI Tooltips are competing with Twitter Bootstrap
    $.widget.bridge('uitooltip', $.ui.tooltip);

    $(elem).uitooltip({
      show: null,
      content: $(elem).attr('title'), 
      position: {
        my: "left top",
        at: "left bottom"
      },
      open: function( event, ui ) {
        ui.tooltip.animate({ top: ui.tooltip.position().top + 5 }, "fast" );
      }
    });   
  }
};

var Settings =
{
    cdn: function (path) {
        var base = Settings.cdnBaseUrl;

        if (base.substring(base.length - 1) !== "/")
            base += "/";

        if (path.substring(0, 1) === "/")
            path = path.substring(1);

        return base + path;
    }
};

var GoalImportance =
{
  GROUP: {
    Need: 'Need',
    Want: 'Want',
    Wish: 'Wish'
  },

  BY_GROUP: {
    Need: 10,
    Want: 7,
    Wish: 3
  },

  GetGroup: function (importance) {
    if (!importance || importance <= 3) {
      return GoalImportance.GROUP.Wish;
    }
    else if (importance <= 7) {
      return GoalImportance.GROUP.Want;
    }
    else {
      return GoalImportance.GROUP.Need;
    }
  }
};

// Add ECMA262-5 Array methods if not supported natively
//http://stackoverflow.com/questions/2790001/fixing-javascript-array-functions-in-internet-explorer-indexof-foreach-etc
//IE8 doesn't implement several of these method so implement it here
if (!('indexOf' in Array.prototype)) {
    Array.prototype.indexOf= function(find, i /*opt*/) {
        if (i===undefined) i= 0;
        if (i<0) i+= this.length;
        if (i<0) i= 0;
        for (var n= this.length; i<n; i++)
            if (i in this && this[i]===find)
                return i;
        return -1;
    };
}

if (!('lastIndexOf' in Array.prototype)) {
    Array.prototype.lastIndexOf= function(find, i /*opt*/) {
        if (i===undefined) i= this.length-1;
        if (i<0) i+= this.length;
        if (i>this.length-1) i= this.length-1;
        for (i++; i-->0;) /* i++ because from-argument is sadly inclusive */
            if (i in this && this[i]===find)
                return i;
        return -1;
    };
}
if (!('forEach' in Array.prototype)) {
    Array.prototype.forEach= function(action, that /*opt*/) {
        for (var i= 0, n= this.length; i<n; i++)
            if (i in this)
                action.call(that, this[i], i, this);
    };
}
if (!('map' in Array.prototype)) {
    Array.prototype.map= function(mapper, that /*opt*/) {
        var other= new Array(this.length);
        for (var i= 0, n= this.length; i<n; i++)
            if (i in this)
                other[i]= mapper.call(that, this[i], i, this);
        return other;
    };
}
if (!('filter' in Array.prototype)) {
    Array.prototype.filter= function(filter, that /*opt*/) {
        var other= [], v;
        for (var i=0, n= this.length; i<n; i++)
            if (i in this && filter.call(that, v= this[i], i, this))
                other.push(v);
        return other;
    };
}
if (!('every' in Array.prototype)) {
    Array.prototype.every= function(tester, that /*opt*/) {
        for (var i= 0, n= this.length; i<n; i++)
            if (i in this && !tester.call(that, this[i], i, this))
                return false;
        return true;
    };
}
if (!('some' in Array.prototype)) {
    Array.prototype.some= function(tester, that /*opt*/) {
        for (var i= 0, n= this.length; i<n; i++)
            if (i in this && tester.call(that, this[i], i, this))
                return true;
        return false;
    };
}
